import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { API_URLS } from '../../../config/api';

const AdminSitemap = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const callGenerate = async (mode) => {
    setLoading(true);
    setMessage('');
    try {
      const res = await fetch(`${API_URLS.ADMIN.ADMIN_API}?action=generateSitemap&mode=${mode}`);
      const raw = await res.text();
      let data;
      try { data = JSON.parse(raw); } catch { data = { status: res.ok ? 'success' : 'error', message: raw }; }
      if (res.ok && (data.status === 'success')) {
        setMessage('sitemap.xml oluşturuldu.');
      } else {
        setMessage(data.message || 'Oluşturma başarısız.');
      }
    } catch (e) {
      setMessage('İstek başarısız.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6 p-4 sm:p-6">
          <h1 className="text-2xl sm:text-3xl font-bold">Sitemap Yönetimi</h1>
      <Card>
        <CardHeader>
          <CardTitle>Kök dizine sitemap.xml oluştur</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-gray-600">Sitemap adı sabit: <code>sitemap.xml</code>. Mod seçimine göre linkler eklenir.</p>
          <div className="flex gap-3">
            <Button onClick={() => callGenerate('static')} disabled={loading}>
              {loading ? 'İşleniyor...' : 'Sitemap Oluştur (Statik)'}
            </Button>
            <Button variant="outline" onClick={() => callGenerate('full')} disabled={loading}>
              {loading ? 'İşleniyor...' : 'İçeriği Oluştur (Tam)'}
            </Button>
          </div>
          {message && <p className="text-sm mt-2">{message}</p>}
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminSitemap;



